import { Layout } from "@/modules/DashboardTemplate/models/Layout";
import { normalizeLayout } from "./normalizeLayout";

export function getMaxWidthAndHeight(items: { layout?: Layout }[]) {
  return items.reduce(
    (acc, item) => {
      const layout = normalizeLayout(item.layout);
      return {
        width: Math.max(acc.width, layout.x + layout.width),
        height: Math.max(acc.height, layout.y + layout.height)
      };
    },
    { width: 0, height: 0 }
  );
}
